<template>
  <div>
  <v-dialog v-model="productsDialog" scrollable max-width="677px">
    <template v-slot:activator="{ on, attrs }" v-if="showButton">
      <div class="text-right">
      <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
      >
        Редактировать
      </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Добавить ингредиенты</v-card-title>
      <v-card-text >
        <v-expansion-panels>
          <v-expansion-panel
                  v-for="productCategory in productCategories"
                  :key="productCategory.id"
                  :id="productCategory.id"
          >
            <v-expansion-panel-header>{{productCategory.name}}</v-expansion-panel-header>
            <v-expansion-panel-content class="without-padding">
              <ul>
                  <li v-for="product in productCategory.related_products" @click="clickOnRow(product)" :class="{selected: product.selected}">
                    <div class="product-item-wrapper">
                      <v-simple-checkbox v-show="product.selected"
                              v-model="product.selected"
                      >
                      </v-simple-checkbox>
<!--                      <v-text-field @click.stop  v-show="product.count > 0" readonly :hide-details="true" :dense="true" v-model="product.count" outlined class="without-border">-->
<!--                        <v-icon slot="prepend" @click.stop="product.count&#45;&#45;">mdi-minus</v-icon>-->
<!--                        <v-icon slot="append" @click.stop="product.count++">mdi-plus</v-icon>-->
<!--                      </v-text-field>-->
                    </div>
                    <div class="name">{{ product.name }}</div>
                  </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="update" :loading="loadingButton">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
  >
    {{ snackbarText }}
  </v-snackbar>
  </div>
</template>

<script>
  import Tabs from './Tabs'
  import ProductService from "../api/ProductService";
  import PromocodeService from "../api/PromocodeService";

  export default {
    name: 'ProductsModal',
    props: {
      productCategories: Array,
      showButton: {
        type: Boolean,
        default: true,
      },
      // products: Array
      value: Object,
    },
    components: {Tabs},
    data() {
      return {
        snackbar: false,
        timeout: 2000,
        snackbarText: '',
        snackbarColor: '',
        productsDialog: false,
        productGroup: {},
        promocode: this.value,
        loadingButton: false,
      };
    },
    methods: {
      init(item){
          this.productsDialog = true
          this.promocode = item
          let _this = this
          this.productCategories.forEach(function (category) {
              category.related_products.forEach(function (product) {
                console.log(123);
                  if(_this.promocode.products.find(prod => prod.id == product.id)){

                      product.selected = true;
                  } else {
                      product.selected = false
                  }
              })
          })
      },
      clickOnRow(product){
        product.selected = !product.selected

      },
      update() {
        var _this = this;
        this.loadingButton = true;

        this.promocode.products = [];

        this.productCategories.forEach(function (category) {
          category.related_products.forEach(function (product) {
            if(product.selected){
              _this.promocode.products.push(product)
            }
          })
        })

        PromocodeService.updateProducts({id: this.promocode.id, items: this.promocode.products}).then(response => {
              this.promocode.products = response.data.products
              this.snackbar = true;
              this.snackbarText = 'Блюда обновлены';
              this.snackbarColor = 'success';
            }).catch(error => {
              this.snackbar = true;
              this.snackbarText = 'Ошибка при обновлении блюд';
              this.snackbarColor = 'error';
            }).finally(() => {
              this.loadingButton = false;
              this.productsDialog = false;
            });

        // ProductService.updateProductsGroupProduct({id: this.promocode.id, items: this.promocode.products}).then(response => {
        //   this.promocode.products = response.data.products
        //   this.snackbar = true;
        //   this.snackbarText = 'Ингредиенты обновлены';
        //   this.snackbarColor = 'success';
        // }).catch(error => {
        //   this.snackbar = true;
        //   this.snackbarText = 'Ошибка при обновлении ингредиентов';
        //   this.snackbarColor = 'error';
        // }).finally(() => {
        //   this.loadingButton = false;
        //   this.productsDialog = false;
        // });

      },
      recheck(){
        var _this = this
        this.productCategories.forEach(function (category) {
          category.related_products.forEach(function (product) {
            //console.log(product.id + ' = ' + )
            if(_this.promocode.products.find(selectedProduct => selectedProduct.id == product.id)){
              product.selected = true
            } else {
              product.selected = false
            }
          })
        })
      }
    },
    mounted() {
      this.recheck();
    },
    watch: {
      productsDialog() {
        this.recheck()
      },
      product(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .without-border {
    .v-input__slot{
      padding: 0!important;
    }
    .v-icon{
      width: 40px;
    }
    .v-input__prepend-outer{
      margin-right: 0;
    }
    .theme--light.v-icon:focus::after {
      opacity: 0;
    }
    input{
      text-align: center;
    }
    &.v-text-field--outlined{
      fieldset {
        border: none!important;
      }
    }
  }
  .without-padding .v-expansion-panel-content__wrap{
    padding: 0;
  }

</style>

<style lang="scss" scoped>

  ul{
    list-style-type: none;
    padding-left: 0;
    li{
      list-style-type: none;
      display: grid;
      grid-template-columns: 42px 1fr;
      margin-bottom: 8px;
      .product-item-wrapper{
        display: grid;
      }
      &.selected{
        background-color: #EEF8FF;
      }
      .name{
        line-height: 40px;
        color: #666;
        font-weight: 500;
        padding-left: 8px;
        font-size: 14px;
      }
    }
  }

</style>
